import React, { useState } from 'react'
import '../App.css'
import axios from 'axios'
import { SERVER_URI } from '../utility/config'
import LoginRequest from './LoginRequest'

function DefaultForwardMessageCreatedMessage(props) {
  window.setTimeout(function () {
    // Move to a new location
    props.handleClose()
  }, 1700)
  return (
    <div>
      <h2 className='message_title'>Uusi viesti luotu</h2>
    </div>
  )
}

function AddDefaultForwardMessage(props) {
  const [show, setShow] = useState(false)
  const [userData, setUserData] = useState({
    cancelMessage: props.cancelMessage,
  })
  let storage = window.localStorage
  let userToken = storage.getItem('admin_token')

  //Look at this closer
  const onChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value })
  }

  // Submit
  const doSubmit = async (e) => {
    e.preventDefault()
    try {
      await axios.post(`${SERVER_URI}/set_cancel_message/`, userData, {
        headers: { Authorization: `Token ${userToken}` },
      })
      props.dispatch({
        type: 'UPDATE_CANCEL_MESSAGE',
        newMessage: userData.cancelMessage,
      })
      setShow(!show)
    } catch (e) {
      console.log('Error in setting cancel message', e)
    }
  }
  return (
    <div className='popUp_card'>
      <div className='popup-box'>
        <div className='box'>
          <span className='close-icon' onClick={props.handleClose}>
            x
          </span>
          {!show && (
            <div>
              <h2 className='popUp_title'>Aseta uusi asiakkaalle lähetettävä viesti </h2>
              <form
                className='rejectionReason_form'
                onSubmit={(e) => doSubmit(e)}
              >
                <label className='label_add' htmlFor='rejectReason'>
                  Viesti:
                </label>
                <br />
                <textarea
                  id='rejectReason'
                  name='cancelMessage'
                  onChange={onChange}
                  rows='4'
                  cols='50'
                  value={userData.cancelMessage}
                  required
                ></textarea>{' '}
                <br className='desktop-break' />
                <input
                  type='submit'
                  id='gradient_Button'
                  value='Aseta viesti'
                />
              </form>
            </div>
          )}
          {show && (
            <DefaultForwardMessageCreatedMessage handleClose={props.handleClose} />
          )}
        </div>
      </div>
    </div>
  )
}

function DefaultForwardMessage(props) {
  props.stopListRefresh()
  const [isOpen, setIsOpen] = useState(false)
  //const [isloggedIn, setIsloggedIn] = useState(true);
  //let storage = window.localStorage;
  //let userToken = storage.getItem("admin_token")

  /*  useEffect(() => {
        const fetchLogin = async () => {
            if (userToken === null) {
                console.log("kirjaudu sisään")
                setIsloggedIn(false)
            }
        }
        fetchLogin();
        // DON'T DELETE THE COMMENT BELOW!!
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) */

  const togglePopUp = async () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className='configurations'>
      {isOpen && (
        <AddDefaultForwardMessage
          cancelMessage={props.cancelMessage}
          dispatch={props.dispatch}
          handleClose={togglePopUp}
        />
      )}
      <h3>
        Edelleenlähetysviesti
      </h3>
      <div className='RejectReason'>
        <div className='reason_list'>
          {props.cancelMessage === undefined ? (
            <LoginRequest />
          ) : (
            props.cancelMessage
          )}{' '}
          <br />
        </div>
      </div>
      <button id='gradient_Button' onClick={togglePopUp}>
        Aseta uusi asiakkaalle lähetettävä viesti
      </button>
    </div>
  )
}

export default DefaultForwardMessage
